import React, { ComponentType } from 'react';
import { useTranslation } from 'hooks';
import type { TranslationKey } from 'hooks/useTranslation';

export type TranslateFn = (key: TranslationKey) => string;

export interface WithTranslationProps {
  t: TranslateFn;
}

const withTranslation = <P extends WithTranslationProps>(Component: ComponentType<P>) => {
  return (props: Omit<P, keyof WithTranslationProps>) => {
    const { t } = useTranslation();
    const allProps = { ...props, t } as P;

    return <Component {...allProps} />;
  };
};

export default withTranslation;
